import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftwordComponent } from './simple-icons-microsoftword.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftwordComponent ],
    exports:      [ SimpleIconsMicrosoftwordComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftwordModule {}
